/* This file is autogenerated, see readme.md for instructions */
import WalkthroughsSvgIcon from '@bloomreach/banana-theme/icons/walkthroughs.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WalkthroughsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WalkthroughsSvgIcon />
    </Icon>
  );
});

WalkthroughsIcon.displayName = 'WalkthroughsIcon';

export default WalkthroughsIcon;
